// @flow
import * as React from 'react';
import { bind } from '@ta/common.api';

import BreadcrumbsAndHeaderOverImage from './BreadcrumbsAndHeaderOverImage';

export { ssrQueries } from '@ta/brand.global-nav';

const BREADCRUMBS_ENDPOINT = '/data/1.0/breadcrumbs';
const ONPAGE_FACTORS_ENDPOINT = '/data/1.0/onpagefactors';

type Props = {
  breadcrumbs: any,
  headerText: string,
  isMobile: boolean,
  flat: string,
};

const ConnectedBreadcrumbsAndHeaderOverImage = (props: Props) =>
  (!props.isMobile && (props.breadcrumbs || props.headerText) && (
    <BreadcrumbsAndHeaderOverImage
      breadcrumbs={props.breadcrumbs}
      headerText={props.headerText}
      flat={props.flat === 'true'}
    />
  )) ||
  null;

// $FlowFixMe92
export default bind((state, stage) => {
  const { meta } = state;
  const servletName = (meta && meta.initialServletName) || '';
  const locationId = state.page.geoId;
  const isMobileWeb = state.meta.device.viewportCategory === 'MOBILE';

  let breadcrumbData;
  let opfsData;
  if (!isMobileWeb && locationId && locationId > 1) {
    const breadcrumbHandle = stage(`${BREADCRUMBS_ENDPOINT}/${locationId}`);
    breadcrumbData = breadcrumbHandle && breadcrumbHandle.get();

    const opfsHandle = stage(
      `${ONPAGE_FACTORS_ENDPOINT}/basic?servletName=${servletName}&locationId=${locationId}`,
    );
    opfsData = opfsHandle && opfsHandle.get();
  }

  return () => ({
    breadcrumbs: breadcrumbData && breadcrumbData.data,
    headerText: opfsData && opfsData.data && opfsData.data.mastheadH1,
    isMobile: isMobileWeb,
  });
})(ConnectedBreadcrumbsAndHeaderOverImage);
